<template>
  <div class="l-content-inner">
    <div class="p-system-wrap">
      <div class="logo-box">
        <a
          href="javascript:void(0);"
          @click="btnCmd('goHome')"
          title="noroo 홈으로 이동"
        >
          <img src="@/assets/images/common/logo_noroo.svg" alt="NOROO" />
        </a>
        <a
          href="javascript:void(0);"
          @click="btnCmd('goHome')"
          title="noroo paint pro 홈으로 이동"
        >
          <img
            src="@/assets/images/common/logo_noroo_paintpro.svg"
            alt="PAINT PRO"
          />
        </a>
      </div>
      <div class="c-status-wrap">
        <div class="icon-box">
          <i class="c-icon icon-nodata size-large"></i>
        </div>
        <div class="text">
          <strong class="c-title-level3">
            <span class="only-pc">원하시는 </span>
            페이지를 찾을 수 없습니다.
          </strong>
          <p class="sub-text">
            입력하신 주소가 잘못되었거나, 페이지가 삭제되었을 수 있습니다.<br />
            아래 버튼을 통해 필요한 정보를 확인해 보세요.
          </p>
        </div>
      </div>
      <div class="navigation-box">
        <a
          href="javascript:void(0);"
          class="btn-back"
          @click="btnCmd('goBack')"
        >
          <i class="c-icon icon-arrow-left-green"></i>
          뒤로가기
        </a>
        <a
          href="javascript:void(0);"
          @click="btnCmd('goHome')"
          class="btn-home"
        >
          홈으로 가기
          <i class="c-icon icon-arrow-right-green"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup name="error404">
import { useRouter } from "vue-router";
const router = useRouter();
/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "goBack") {
    if (window.history.length > 1) {
      window.history.back(); // 브라우저 히스토리가 1보다 크면 이전 페이지로 돌아감
    } else {
      router.push("/"); // 히스토리가 없으면 특정 페이지로 리디렉션 (예: 홈 페이지)
    }
  } else if (cmd === "goHome") {
    location.href = "/paintpro/main";
  } else {
    alert(
      `[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` +
        JSON.stringify(parms, null, " ")
    );
    return false;
  }
}
</script>
